function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./DatePicker.module.sass";
const DatePicker = props => {
  const {
    name,
    className,
    value,
    dateFormat,
    ...inputProps
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles["wrap-datepicker"]
  }, name && /*#__PURE__*/React.createElement("h5", {
    className: styles["label"]
  }, name), /*#__PURE__*/React.createElement(ReactDatePicker, _extends({
    className: `${styles["input-label-style"]}`,
    name: name,
    showPopperArrow: false,
    selected: value
  }, inputProps, {
    dateFormat: dateFormat || "yyyy-MM-dd"
  })));
};
export default DatePicker;